import { render } from "./moh711.vue?vue&type=template&id=4fd48df6&scoped=true"
import script from "./moh711.vue?vue&type=script&lang=js"
export * from "./moh711.vue?vue&type=script&lang=js"

import "./moh711.vue?vue&type=style&index=0&id=4fd48df6&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fd48df6"]])

export default __exports__